import { createContext } from "react";

// NOTE: NSAI-6787 — the current organization's custom PII entities, keyed by
// placeholder type (CUSTOM_EMPLOYEE_ID → "Employee ID"). Null outside the
// provider (the admin area) and while the labels have not arrived; chips then
// fall back to the humanized type, never the raw identifier.
export const PiiCustomEntityLabelsContext = createContext<ReadonlyMap<
  string,
  string
> | null>(null);
